import './tabs.scss';

$('.tabs').each(function () {
	let $tabs = $(this);

	$tabs.on('click', '.tabs__tab', function () {
		let $active_tab = $(this);
		let $all_tabs = $tabs.find('.tabs__tab');

		$all_tabs.removeClass('tabs__tab_active');
		$active_tab.addClass('tabs__tab_active');

		$tabs.trigger('change', $all_tabs.index($active_tab));
	});
})
